import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import Navbar from "@/components/Navbar";
import Logo from "@/components/Logo";
import PhoneOtpAuth from "@/components/PhoneOtpAuth";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "+91 ", password: "" });
  const [loading, setLoading] = useState(false);

  const setField = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await register(form);
    setLoading(false);
    if (r.ok) {
      toast.success("Account created!");
      nav("/dashboard");
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar variant="public" />
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="soft-card p-8">
          <Logo variant="auth" testId="register-logo" className="mb-6" />
          <div className="chip-light mb-3 mx-auto w-fit">Create account</div>
          <h1 className="font-display text-3xl font-extrabold text-slate-900 text-center">Book your first session</h1>
          <p className="text-slate-500 mt-1 text-center">Flat ₹599 per fix. Cancel anytime before the call.</p>

          <Tabs defaultValue="phone" className="mt-6" data-testid="register-auth-tabs">
            <TabsList className="grid grid-cols-2 bg-slate-100 border border-slate-200 p-1 rounded-xl w-full">
              <TabsTrigger value="phone" data-testid="register-tab-phone" className="rounded-lg data-[state=active]:bg-white data-[state=active]:shadow-sm font-semibold">
                Phone + OTP
              </TabsTrigger>
              <TabsTrigger value="email" data-testid="register-tab-email" className="rounded-lg data-[state=active]:bg-white data-[state=active]:shadow-sm font-semibold">
                Email
              </TabsTrigger>
            </TabsList>

            <TabsContent value="phone" className="mt-5">
              <PhoneOtpAuth mode="register" redirectTo="/dashboard" />
            </TabsContent>

            <TabsContent value="email" className="mt-5">
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label className="font-semibold">Your name</Label>
                  <Input data-testid="register-name-input" required value={form.name} onChange={setField("name")} className="mt-1 border border-slate-200 focus-visible:ring-2 focus-visible:ring-blue-500 h-11" />
                </div>
                <div>
                  <Label className="font-semibold">Email</Label>
                  <Input data-testid="register-email-input" type="email" required value={form.email} onChange={setField("email")} className="mt-1 border border-slate-200 focus-visible:ring-2 focus-visible:ring-blue-500 h-11" />
                </div>
                <div>
                  <Label className="font-semibold">Phone</Label>
                  <Input data-testid="register-phone-input" required value={form.phone} onChange={setField("phone")} placeholder="+91 98765 43210" className="mt-1 border border-slate-200 focus-visible:ring-2 focus-visible:ring-blue-500 h-11" />
                </div>
                <div>
                  <Label className="font-semibold">Password</Label>
                  <Input data-testid="register-password-input" type="password" required minLength={6} value={form.password} onChange={setField("password")} className="mt-1 border border-slate-200 focus-visible:ring-2 focus-visible:ring-blue-500 h-11" />
                </div>
                <Button type="submit" disabled={loading} data-testid="register-submit-btn" className="w-full bg-brand hover:bg-brand-dark text-white rounded-full shadow-btn font-bold h-11">
                  {loading ? "Creating…" : "Create account"}
                </Button>
              </form>
            </TabsContent>
          </Tabs>

          <div className="mt-6 text-sm text-slate-500 text-center">
            Have an account? <Link to="/login" className="font-semibold text-slate-900 underline" data-testid="link-login">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
